import { connect } from 'react-redux';
import { participantCount } from '@core/selectors/classroom';
import { getCurrentSpaceId } from '@core/selectors/space';
import CommonRoomResponsive from './CommonRoomResponsive';

const mapStateToProps = (state) => ({
  participantTotal: participantCount(state),
  spaceId: getCurrentSpaceId(state),
});

export default connect(mapStateToProps)(CommonRoomResponsive);
